export type LeadType = 'CUSTOMER' | 'PARTNER';

export type LeadStatus = 'NEW' | 'CONTACTED' | 'IN_DISCUSSION' | 'WON' | 'LOST';

export type ActivityType = 'NOTE' | 'CALL' | 'MESSAGE' | 'FORM_SUBMISSION' | 'STATUS_CHANGE' | 'CREATED';

export interface Lead {
  id: string;
  user_id: string;
  full_name: string;
  email: string | null;
  phone: string | null;
  lead_type: LeadType;
  status: LeadStatus;
  source: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
  last_activity_at: string | null;
}

export interface LeadTag {
  id: string;
  user_id: string;
  name: string;
  created_at: string;
}

export interface LeadTagAssignment {
  id: string;
  lead_id: string;
  tag_id: string;
}

export interface LeadActivity {
  id: string;
  user_id: string;
  lead_id: string;
  type: ActivityType;
  content: string;
  created_at: string;
}

export interface LeadWithTags extends Lead {
  tags: LeadTag[];
}

export interface CreateLeadInput {
  full_name: string;
  email?: string;
  phone?: string;
  lead_type: LeadType;
  status?: LeadStatus;
  source?: string;
  notes?: string;
  tag_ids?: string[];
}

export interface UpdateLeadInput {
  full_name?: string;
  email?: string | null;
  phone?: string | null;
  lead_type?: LeadType;
  status?: LeadStatus;
  source?: string | null;
  notes?: string | null;
  tag_ids?: string[];
}

export interface CreateActivityInput {
  lead_id: string;
  type: ActivityType;
  content: string;
}

export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = {
  NEW: 'Neu',
  CONTACTED: 'Kontaktiert',
  IN_DISCUSSION: 'In Gespräch',
  WON: 'Gewonnen',
  LOST: 'Verloren',
};

export const LEAD_TYPE_LABELS: Record<LeadType, string> = {
  CUSTOMER: 'Kunde',
  PARTNER: 'Partner',
};

export const ACTIVITY_TYPE_LABELS: Record<ActivityType, string> = {
  NOTE: 'Notiz',
  CALL: 'Anruf',
  MESSAGE: 'Nachricht',
  FORM_SUBMISSION: 'Formular',
  STATUS_CHANGE: 'Status',
  CREATED: 'Erstellt',
};
